export enum AirbnbCheckInOptions {
  DOORMAN_ENTRY = 'doorman_entry',
  LOCKBOX = 'lockbox',
  SMARTLOCK = 'smartlock',
  KEYPAD = 'keypad',
  HOST_CHECKIN = 'host_checkin',
  OTHER_CHECKIN = 'other_checkin',
}
